module.exports = __webpack_public_path__ + "img/SA.40f2c539.svg";